import React from "react";
import { ResultPaginationLoadMoreProps } from "@usereactify/search";

export type ExampleResultPaginationLoadMoreProps = React.ComponentProps<
    NonNullable<ResultPaginationLoadMoreProps["render"]>
>;

export const LoadMore: React.FC<ExampleResultPaginationLoadMoreProps> =
(props) => {

    return (
        <>
        {props.hasMore && <div className={`flex justify-center p-8`}>
            <a
            className="uppercase rs__pagination__loadmore-button h2 gap-[12px] items-center cursor-pointer"
            onClick={() => props.handleLoadMore()}
            disabled={!props.hasMore}
        >
            {"Load more"}
            <i className={`icon icon-plus text-[12px]`}></i>
        </a>
        </div>}
        </>
    );
};